import React from "react";
import styled from "styled-components";
import Sidebar from "./Sidebar";

const Page = styled.main`
  min-height: 70vh;
  padding: 22px 18px 40px;
  background: #f7fafc;
`;

const Grid = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 16px;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`;

const Content = styled.section`
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  box-shadow: 0 12px 34px rgba(0,0,0,0.06);
  padding: 16px;
`;

const Title = styled.h1`
  margin: 0 0 12px 0;
  font-size: 22px;
  font-weight: 950;
  color: #111827;
`;

export default function AdminShell({ title, children }) {
  return (
    <Page>
      <Grid>
        <div>
          <Sidebar />
        </div>

        <Content>
          <Title>{title}</Title>
          {children}
        </Content>
      </Grid>
    </Page>
  );
}
